import { getData, navigateV2 } from './router';
import { clearUserCache, getLangLocale, getMemoizedData } from './memo';
import axios from 'axios/index';
import T, { t } from '../components/T';
import { zendoStorage } from '../../hybrid/wrappers';
import { useEffect, useMemo, useState, useContext, useRef } from 'react';
import { LangContext } from '../decorators/Language';
import UserContext from './getContext';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import uikit from '../../project/uikit/uikit.module.scss';
import { generateServerUrl, generateSiteUrl } from '../../scripts/getSiteUrl';
import { getDatePlaceholder } from '../../widgets/form/components/form-date/initData';
import moment from 'moment';
import timezone from 'moment-timezone';
const project = require('../../scripts/configs/project.json');
import qs from 'qs';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Переменные среды
export function generateUniqueId(uniq = '') {
    return `id-${Date.now()}-${Math.random().toString(36).slice(2, 11)}${uniq}`;
}

// получение элемента с LocalStorage
export const getLocalStorageItem = (key, defaultValue, needToAddToLs, needToParseValue) => {
    try {
        let ls_item = zendoStorage.get(key);
        if (!ls_item) {
            if (needToAddToLs) {
                zendoStorage.set(key, defaultValue);
            }
            return defaultValue;
        }
        if (needToParseValue) {
            ls_item = JSON.parse(ls_item);
        }
        return ls_item;
    } catch (e) {
        return defaultValue;
    }
};

const getServerUrl = () => {
    return generateServerUrl({
        DOMAINS: process.env.NEXT_PUBLIC_DOMAINS,
        ISCOPY: process.env.NEXT_PUBLIC_ISCOPY,
        BACK_URL: process.env.NEXT_PUBLIC_SERVER_BACK_URL
    });
};
export const API_SERVER_URL = getServerUrl();

const getSiteUrl = () => {
    return generateSiteUrl({
        DOMAINS: process.env.NEXT_PUBLIC_DOMAINS,
        ISCOPY: process.env.NEXT_PUBLIC_ISCOPY,
        FRONT_URL: process.env.NEXT_PUBLIC_SERVER_FRONT_URL
    });
};
export const SITE_URL = getSiteUrl();

export const WSS_PORT = process.env.NEXT_PUBLIC_WSS_PORT;

// Получение списка пунктов меню для определенного пользователя
export const rolesMenu = (menus, dataRoles, profileData) => {
    if (profileData) {
        return menus
            ? menus?.filter((m) =>
                  m?.hideUnactive && profileData?.marketing_profile?.activity === false
                      ? false
                      : m.showAll ||
                        !m?.roles.length ||
                        m?.roles?.some((r) => dataRoles && dataRoles.find((u) => u.name === r || u.name === 'superadmin'))
              ) || []
            : [];
    }
    return menus
        ? menus?.filter(
              (m) =>
                  m.showAll ||
                  !m?.roles.length ||
                  m?.roles?.some((r) => dataRoles && dataRoles.find((u) => u.name === r || u.name === 'superadmin'))
          ) || []
        : [];
};

// Разлогин
export const logOutFunction = async () => {
    clearUserCache();
    navigateV2('/logout', true);
};

// Объединение списка групп со списком полей формы
export const compileGroupsData = (dataTabs, dataFields, translation) => {
    if (dataTabs && dataFields) {
        return dataTabs.reduce((accum, tab) => {
            accum[tab.alias] = {
                title: tab.title,
                fields:
                    tab.alias === 'basic'
                        ? dataFields
                              .filter((field) => field.group === tab.alias)
                              .map((el) =>
                                  !!el?.placeholder && !!el?.disabled
                                      ? {
                                            ...el,
                                            tooltip: t(
                                                'input-tooltip-disabled',
                                                'Для изменения данных после прохождения верификации обратитесь в службу поддержки',
                                                '/profile',
                                                translation
                                            )
                                        }
                                      : el
                              )
                        : dataFields.filter((field) => field?.group === tab.alias)
            };

            return accum;
        }, {});
    }
    return false;
};

// Получение корзины
export const getCartData = async (cartId, userToken, lang, ip, currency, subUser) => {
    if (!cartId && !userToken) {
        return {};
    }
    let cart = '';
    if (cartId) {
        cart = `/${cartId}`;
    }

    let headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8',
        ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
        ...(ip ? { ClientNodeIp: ip } : {}),
        ...(lang ? { 'Accept-Language': lang } : {})
    };

    if (currency) {
        headers['Accept-Currency'] = currency;
    }

    try {
        let response = await fetch(`${API_SERVER_URL}/api/v1/shop/carts${cart}`, {
            method: cartId ? 'GET' : 'POST',
            headers,
            body: subUser
                ? JSON.stringify({
                      user_id: subUser // Передаємо дані в запит
                  })
                : null
        });
        return await response.json();
    } catch (e) {
        console.warn(e.message);
        return false;
    }
};

// Определение окончаний слов в зависимости от количества
export const declOfNum = (n, text_forms) => {
    n = Math.abs(n) % 100;
    let n1 = n % 10;
    if (n > 10 && n < 20) {
        return text_forms[2];
    }
    if (n1 > 1 && n1 < 5) {
        return text_forms[1];
    }
    if (n1 === 1) {
        return text_forms[0];
    }
    return text_forms[2];
};

// Получение прогресса для радиального прогресс-бара
export const getStatusProgress = (data) => {
    let conditionDone = 0;
    let conditionLength = 0;
    let diff = data ? 100 : 0;
    if (!!data?.conditions) {
        conditionLength = Object.keys(data?.conditions).length;
        data?.conditions?.next_rank_package?.has_package && conditionDone++;
        if (!!data?.conditions?.volumes) {
            conditionLength = conditionLength + data?.conditions?.volumes?.length - 1;
            data?.conditions?.volumes.forEach((volume) => {
                if (volume.accumulated >= volume.target) {
                    conditionDone++;
                }
            });
        }
        if (data.conditions.branches_with_rank?.number) {
            conditionLength = conditionLength + Math.floor(data.conditions.branches_with_rank?.number) - 1;
            conditionDone = conditionDone + Math.floor(data.conditions.branches_with_rank?.target_number);
        }
        diff = !!conditionDone && !!conditionLength ? (100 / conditionLength) * conditionDone : 0;
        if (data?.next_rank_logical_operator === 'or') {
            if (data?.conditions?.next_rank_package?.has_package) {
                diff = 100;
            }
            if (!!data?.conditions?.volumes) {
                let volumes = data?.conditions?.volumes.every((volume) => {
                    return volume.accumulated >= volume.target;
                });
                if (volumes) diff = 100;
            }
            if (data.conditions.branches_with_rank?.number >= data.conditions.branches_with_rank?.target_number) {
                diff = 100;
            }
        }
    }
    if (diff > 100) {
        diff = 100;
    }
    return {
        dasharray: 394,
        dashoffset: ((394 - 109) * (100 - diff)) / 100 + 109
    };
};

export const useCategoriesData = (categoriesData, categoriesMeta) => {
    const [data, setData] = useState(categoriesData);
    const [nextLink, setNextLink] = useState(categoriesMeta?.next);
    const { userToken, lang, localization } = useContext(UserContext);
    useEffect(() => {
        setData(categoriesData);
        setNextLink(categoriesMeta?.next);
    }, [categoriesData, categoriesMeta]);

    const loadMoreCategories = useMemo(() => {
        if (nextLink) {
            return () => {
                getMemoizedData(nextLink, userToken, lang, false, localization?.currency).then((newData) => {
                    setData((pre) => [...pre, ...newData?.data]);
                    setNextLink(newData?.links?.next);
                });
            };
        }
        return null;
    }, [lang, localization?.currency, nextLink, userToken]);
    return {
        categories: data,
        loadMoreCategories
    };
};

// Получить url без get-параметров
export const removeURLParameter = (url, parameter) => {
    let urlparts = url?.split('?');
    if (urlparts.length >= 2) {
        let prefix = encodeURIComponent(parameter) + '=';
        let pars = urlparts[1]?.split(/[&;]/g);

        for (let i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
};

// Установить язык писем для пользователя
export const setLanguageForEmail = async (userToken, lang) => {
    try {
        return await axios({
            method: 'POST',
            url: `${API_SERVER_URL}/api/v1/user/profile/lang-code`,
            headers: {
                ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            data: { language_code: lang }
        });
    } catch (e) {
        return console.warn('error', e);
    }
};
export async function getWidgetTranslates(lang, widget, translates, setTranslates = () => {}) {
    const staticData = translates?.widget_translates?.[widget]?.data;
    if (!staticData) {
        const transData = await getLangLocale(lang, null, widget);
        if (transData?.data) {
            setTranslates(transData.data);
            return transData.data;
        } else {
            setTranslates({});
            return {};
        }
    } else {
        setTranslates(staticData);
        return staticData;
    }
}

export const useWidgetTranslates = (alias) => {
    const { translation } = useContext(LangContext) || {};
    const [trans, setTranslates] = useState(null);

    const { lang } = useContext(UserContext);

    useEffect(() => {
        getWidgetTranslates(lang, alias, translation, setTranslates);
    }, [lang, translation, alias]);

    return trans;
};

export const camelizeStyles = (styles) => {
    if (!styles) return styles;
    const replacer = (s) => s.replace(/-./g, (x) => x[1].toUpperCase());
    return Object.keys(styles)?.reduce(
        (acc, curr) => ({
            ...acc,
            [replacer(curr)]: styles[curr]
        }),
        {}
    );
};

export const checkFileSize = (image, scale) =>
    new Promise((resolve) => {
        let img = new Image();
        img.onload = function () {
            if (this.width > scale || this.height > scale) {
                resolve(false);
            } else {
                resolve(image);
            }
        };
        img.onerror = function () {
            resolve(image);
        };

        img.src = image;
    });

export const getFullDateFormatString = (settings) => {
    const dateFormat = () => {
        switch (settings?.date_format) {
            case '0': {
                return 'MMM DD, YYYY';
            }
            case '1': {
                return 'YYYY-MM-DD';
            }
            case '2': {
                return 'DD/MM/YYYY';
            }
            case '3': {
                return 'DD.MM.YYYY';
            }
            default:
                return 'YYYY-MM-DD';
        }
    };
    const timeFormat = () => {
        switch (settings?.time_format) {
            case '0':
                return 'h:mm a';
            case '1':
                return 'h:mm A';
            case '2':
                return 'HH:mm';
            default:
                return 'HH:mm';
        }
    };

    return `${dateFormat()} ${timeFormat()}`;
};

export const useRandom = () => {
    const [randomNumber, setRandomNumber] = useState(0);
    useEffect(() => {
        setRandomNumber(Math.floor(Math.random() * 10000000));
    }, []);
    return randomNumber;
};

export const useIsFirstRender = () => {
    const isFirst = useRef(true);

    if (isFirst.current) {
        isFirst.current = false;

        return true;
    }

    return isFirst.current;
};

export const rolesUrls = {
    finance: '/admin/finance',
    translator: '/admin/languages'
};

export const getIsTouchDevice = () => {
    if (typeof window !== 'undefined' && window?.navigator) {
        if ('maxTouchPoints' in navigator) {
            if (navigator.maxTouchPoints > 0) {
                const mQ = matchMedia?.('(pointer: coarse)');
                return !!mQ.matches && navigator.maxTouchPoints > 0;
            }
            return false;
        } else if ('msMaxTouchPoints' in navigator) {
            if (navigator.msMaxTouchPoints > 0) {
                const mQ = matchMedia?.('(pointer: coarse)');
                return !!mQ.matches && navigator.msMaxTouchPoints > 0;
            }
            return false;
        } else {
            const mQ = matchMedia?.('(pointer: coarse)');
            if (mQ?.media === '(pointer: coarse)') {
                return !!mQ.matches;
            } else if ('orientation' in window) {
                return true; // Deprecated, but good fallback
            } else {
                // Only as a last resort, fall back to user agent sniffing
                const UA = navigator.userAgent;
                return /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
            }
        }
    }
    return false;
};

export const useIsTouchDevice = () => {
    /**
     *
     * function copied from
     * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
     *
     * */

    const [hasTouchScreen, setHasTouchScreen] = useState(false);

    useEffect(() => {
        setHasTouchScreen(getIsTouchDevice());
    }, []);

    return hasTouchScreen;
};

export const combineData = (data1, data2) => {
    if (!data1?.length || !data2?.length) {
        return data2 || data1;
    }
    return data1.map((item, index) => ({ ...item, ...data2[index] }));
};
export const useRouteAnimation = (disable) => {
    const { routerLoader } = useContext(UserContext);
    const router = useRouter();
    const stage1 = router.asPath === routerLoader?.to;
    const stage2 = !routerLoader;

    return disable
        ? ''
        : classNames({
              [uikit.routeTransition]: stage1,
              [uikit.routeTransition2]: stage2
          });
};

export const useDoubleDatePlaceholder = () => {
    const translation = useWidgetTranslates('form');
    const { settings } = useContext(UserContext);
    const double = (text) => text + ' - ' + text;
    return double(getDatePlaceholder(settings, false, translation));
};

export const checkIsArray = (data) => Array.isArray(data);

export const getDaysLabel = (value) => {
    const number = Number(value);
    if (isNaN(number)) return 'Is not a number';
    const lastDigit = number % 10;

    const numbers = [1];
    const numbers2 = [5, 6, 7, 8, 9, 0];

    switch (true) {
        case numbers.includes(lastDigit): {
            return <T textName='day' defaultStr='день' />;
        }
        case numbers2.includes(lastDigit): {
            return <T textName='day-2' defaultStr='дней' />;
        }
        default:
            return <T textName='day-3' defaultStr='дня' />;
    }
};

export const addedMenuItems = (profileData) => {
    return {
        office: [
            {
                roles: [],
                type: 'link',
                link: `/treegraph/matrix/${profileData?.marketing_profile?.node_id}`,
                title: { default: <T textName='menu-office-item-1' defaultStr='Бинарная структура' /> },
                location: 'office',
                showAll: true,
                activity: true,
                parent: '614c163149a8b53dd07071e3',
                _id: 'office_added_item_0-1'
            }
        ]
    };
};

export const checkVerification = (userToken, lang, successFunc, errorFunc) => {
    getData('/api/v1/user/verification', userToken, lang)
        .then((res) => {
            const isVerified = res?.data?.status?.value === 'verified';
            if (isVerified) {
                successFunc();
            } else {
                errorFunc();
            }
        })
        .catch(console.warn);
};

export function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + (opacity ? `,${opacity}` : ',1)');
    }
    throw new Error('Bad Hex');
}
export const downloadQR = (id, name) => {
    const svg = document.getElementById(id);
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const pngFile = canvas.toDataURL('image/png');
        const downloadLink = document.createElement('a');
        downloadLink.download = name;
        downloadLink.href = `${pngFile}`;
        downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};

export const getDifferenceBetweenDates = (date1, date2) => {
    return parseFloat(moment(date1).diff(moment(date2), 'hours', true).toFixed(1).toString());
};

export const convertTimeToAM = (time, user_timezone, options = {}) => {
    const { format } = options;
    return timezone
        .tz(time, user_timezone)
        .locale('en')
        .format(format || 'hh:mm A');
};

export const getEventDuration = (event, translation, options = {}) => {
    const { returnObj } = options;
    if (returnObj) {
        return {
            date: `${event?.event_start_time} - ${event?.event_end_time}`,
            duration: `(${getDifferenceBetweenDates(moment(event.user_end_time), moment(event.user_start_time))}${t(
                'hours-short',
                'ч',
                'all',
                translation
            )})`,
            allDay: getDifferenceBetweenDates(moment(event.user_end_time), moment(event.user_start_time)) == 24
        };
    }
    return `${event.event_start_time} - ${event.event_end_time} (${getDifferenceBetweenDates(
        moment(event.user_end_time),
        moment(event.user_start_time)
    )}${t('hours-short', 'ч', 'all', translation)})`;
};

export const printPdfFromBinar = async (response, openPrint) => {
    const buffer = await response.arrayBuffer();
    const blob = new Blob([buffer], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    // Відкрити PDF у новій вкладці
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
        newWindow.addEventListener('load', () => {
            newWindow.focus();
            // newWindow.print();
        });
        // відкривати iframe для друку
    } else if (openPrint) {
        // Якщо нові вкладки блокуються, вбудувати PDF у сторінку
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.addEventListener('load', () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        });
    }
};

export const downloadPdfFromBinar = async (res, filename) => {
    const buffer = await res.arrayBuffer();
    const blob = new Blob([buffer], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'test' + '.pdf';
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const isToday = (timestamp) => {
    // Отримуємо сьогоднішню дату
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Обнуляємо години, хвилини, секунди, мілісекунди

    // Перетворюємо timestamp на дату та обнуляємо час
    const dateToCheck = new Date(timestamp);
    dateToCheck.setHours(0, 0, 0, 0);

    // Порівнюємо дві дати
    return today.getTime() === dateToCheck.getTime();
};

export const copyToClipboard = (text, options = {}) => {
    navigator.clipboard
        .writeText(text)
        .then(() => {
            const { setAlertData, alertText } = options;
            if (setAlertData && alertText) {
                setAlertData({
                    type: 'success',
                    cont: alertText
                });
            }
        })
        .catch((error) => {
            console.error(error);
        });
};

export const getOfficeSearchGridConfig = (customCss) => ({
    0: {
        th: {
            className: customCss.w500
        }
    },
    1: {
        th: {
            className: customCss.w245
        }
    },
    activeRow: {
        deleted: { background: 'var(--notSuccessOp5)' },
        blocked: { background: 'rgba(var(--orange) / 0.1)' },
        is_new_partner: { background: 'var(--successSuccess01Op5)' }
    }
});

export const extractYouTubeVideoID = (input) => {
    if (!input || typeof input !== 'string') return null;

    // 1️⃣ Чистый ID
    if (/^[A-Za-z0-9_-]{11}$/.test(input)) {
        return input;
    }

    try {
        const url = new URL(input);

        // youtu.be/<id>
        if (url.hostname === 'youtu.be') {
            return url.pathname.slice(1, 12);
        }

        // *.youtube.com
        if (url.hostname.includes('youtube.com')) {
            // watch?v=<id>
            if (url.searchParams.has('v')) {
                return url.searchParams.get('v');
            }

            // /embed/<id>, /v/<id>, /shorts/<id>
            const match = url.pathname.match(/\/(embed|v|shorts)\/([A-Za-z0-9_-]{11})/);

            if (match) {
                return match[2];
            }
        }
    } catch {
        // если это не валидный URL — просто пропускаем
    }

    return null;
};

export const getIsSafari = () => {
    return (
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
            return p.toString() === '[object SafariRemoteNotification]';
        })(
            !window['safari'] ||
                // Перевірка на safari наступний рядок - RS
                // eslint-disable-next-line no-undef
                (typeof safari !== 'undefined' && safari.pushNotification)
        )
    );
};

export const getWithZoom = (scroll) => {
    let width = window.innerWidth;
    const zoom = Number(window.getComputedStyle(document.querySelector('html'), null).zoom);
    if (project.zooming && zoom === zoom && zoom < 1 && width < 1650 && width >= 1300) {
        return scroll / zoom;
    }
    return scroll;
};

export const getIsOpera = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('opera') || userAgent.includes('opr') || userAgent.includes('opios');
};

export const checkBrowser = (scroll) => {
    //специфічні стилі для safari + opera
    return getIsSafari() || getIsOpera() ? scroll : getWithZoom(scroll);
};

export const checkSafari = (scroll) => {
    //специфічні стилі для safari
    return getIsSafari() ? scroll : getWithZoom(scroll);
};
export const cleanProps = (data, toClean) => {
    return Object.keys(data).reduce((accum, name) => {
        if (!toClean.includes(name)) {
            accum[name] = data[name];
        }

        return accum;
    }, {});
};

export const saveFilterForPage = (page, params) => {
    // Створюємо рядок запиту на основі параметрів
    const queryObject = qs.parse(params);
    const queryString = qs.stringify(queryObject, { encode: false });

    // Завантажуємо поточні дані з localStorage або створюємо новий об'єкт
    const allFilters = JSON.parse(localStorage.getItem('pageFilters') || '{}');

    // Оновлюємо або додаємо фільтр для конкретної сторінки
    allFilters[page] = queryString;

    // Зберігаємо оновлений об'єкт назад у localStorage
    localStorage.setItem('pageFilters', JSON.stringify(allFilters));
};
export const getFilterForPage = (page) => {
    const allFilters = JSON.parse(localStorage.getItem('pageFilters') || '{}');
    return allFilters[page] || ''; // Повертає рядок запиту або null, якщо даних немає
};

export const removeFilterForPage = (page) => {
    // Завантажуємо всі збережені фільтри з localStorage
    const allFilters = JSON.parse(localStorage.getItem('pageFilters') || '{}');

    // Перевіряємо, чи існує фільтр для вказаної сторінки
    if (allFilters[page]) {
        delete allFilters[page]; // Видаляємо фільтр для сторінки

        // Зберігаємо оновлений об'єкт назад у localStorage
        localStorage.setItem('pageFilters', JSON.stringify(allFilters));
    }
};

export const getUserCurrencyAccounts = async (filters = '', currency, userToken, lang) => {
    return await getMemoizedData(`/api/v1/user/finance/currency-accounts${filters}`, userToken, lang, currency);
};

export const phoneFormatter = (phone) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(`+${phone?.replaceAll('+', '')}`);
        if (!phoneNumber) return phone;

        let formatted = phoneNumber.formatInternational(); // Формат: +7 495 123 45 67

        // Добавляем скобки вокруг кода региона
        return formatted.replace(/(\+\d{1,3}) (\d{2,4})/, '$1 ($2)');
    } catch {
        return phone;
    }
};

export const getDocumentByCountry = (countryTag, documentName) => {
    let tag = countryTag?.toLowerCase();
    const availableCountries = ['kz', 'kg', 'ru', 'uz'];

    if (!availableCountries.includes(tag)) {
        tag = 'kz';
    }

    return `docs/new/${tag}/${documentName}.pdf`;
};

export const getCountryIdByDomain = (topLevelDomain) => {
    const availableCountries = {
        ru: 2017370,
        kz: 1522867,
        uz: 1512440,
        kg: 1527747
    };
    return availableCountries[topLevelDomain];
};

// вирізає окремо валюту окремо число з строки
export const getNumberAndCurrencyFromString = (str) => {
    if (str && typeof str === 'string') {
        const match = str.match(/^\s*([^\d.,-]*?)\s*([\d\s.,-]+)\s*([^\d.,-]*)\s*$/);
        if (match) {
            const [, prefixCurrency, numberPart, suffixCurrency] = match;
            const currency = prefixCurrency || suffixCurrency;
            const numeric = numberPart.replace(/\s/g, '').replace(',', '.'); // чистим пробелы и запятые

            return {
                number: numeric,
                currency: currency
            };
        }
    }

    return {
        number: 0,
        currency: ''
    };
};
